import {
  portalCapabilityPermission,
  type PortalCapabilityAction,
  type PortalCapabilityArea,
  type PortalCapabilityPermission,
  type PortalRoleAccessSnapshot,
} from "@whitehaven/permissions";

export function permissionForRoleAccessCell(
  area: PortalCapabilityArea,
  action: PortalCapabilityAction,
): PortalCapabilityPermission {
  return portalCapabilityPermission(area, action);
}

export function setRoleAccessPermission(
  current: readonly PortalCapabilityPermission[],
  permission: PortalCapabilityPermission,
  checked: boolean,
): readonly PortalCapabilityPermission[] {
  const next = new Set(current);
  if (checked) next.add(permission);
  else next.delete(permission);
  return [...next].sort();
}

export function sameRoleAccessPermissions(
  left: readonly PortalCapabilityPermission[],
  right: readonly PortalCapabilityPermission[],
): boolean {
  if (left.length !== right.length) return false;
  const expected = new Set(left);
  return right.every((permission) => expected.has(permission));
}

export function roleAccessSections(snapshot: PortalRoleAccessSnapshot) {
  const sections = new Map<
    string,
    PortalRoleAccessSnapshot["areas"][number][]
  >();

  for (const area of snapshot.areas) {
    const current = sections.get(area.section) ?? [];
    current.push(area);
    sections.set(area.section, current);
  }

  return [...sections.entries()].map(([label, areas]) => ({ label, areas }));
}
